module.exports = __webpack_public_path__ + "img/GDQ-svarsstapel_00.5be3aeac.gif";